// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.logo[data-v-7f2f7480]{\r\n    position: absolute;\r\n    left: 10px;\r\n    top: 12px;\n}\n.main-menu[data-v-7f2f7480]{\r\n    margin-top: 10px;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
